<template>
  <div class="contentPage">
    <main-table
      v-if="bonusChargeFilter"
      page-title="Bonus/charge for employee"
      default-sort-by="id"
      :default-sort-desc="true"
      :uniqId="uniqId"
      :settings="getSettings"
      flag="bonus-charge"
      :headers="headers"
      :filters-list="bonusChargeFilter"
      :list-items="bonusChargeList"
      @updateEdit="onEdit"
      @updateChangeSort="onFilter"
      @updateRefreshFilters="onFilter"
      @updateSearch="onFilter"
      @updateEvent="onEvent"
      @updateSettings="onSettingsOpen"
      @updateExport="onExport"
      @updateFile="onPreview"
      @updateClickButton="onClickButton"
      isSettings
    ></main-table>
    <bonus-charge-create
      v-if="isBonusChargeCreate"
      :itemId="itemId"
      @updateClose="onClose"
    ></bonus-charge-create>
    <table-settings
      v-if="isTableSettingsDrawer"
      @updateSettingsSave="onSettingsSave('bonus-charge')"
      @updateSettingsCancel="onSettingsCancel"
      @updateSettingsClose="onSettingsClose"
      @updateSettingsAll="onSettingsAll"
      :settings="getSettings"
    ></table-settings>
    <remove-block
        v-if="isRemove"
        @updateRemoveItem="onRemoveItem"
        @updateRemoveClose="onRemoveClose"
        :preloader="isPreloader"
    ></remove-block>
	  <preview-document v-if="previewLink" :width="800"></preview-document>
  </div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components async
const BonusChargeCreate = () => import("@/components/Accounting/BonusCharge/BonusChargeCreate/BonusChargeCreate");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// shared
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS } from "@/constants/constants";
import previewMixins from "@/mixins/previewMixins";

export default {
	name: "BonusCharge",
	mixins: [ settingsMixins, removeMixins, previewMixins ],
	components: { PreviewDocument, BonusChargeCreate, RemoveBlock, },
	computed: mapGetters([ "bonusChargeList", "bonusChargeFilter", "permissions" ]),
	data: () => ({
		isBonusChargeCreate: false,
		removeId: null,
		isPreloader: false,
		previewLink: false,
	}),
	methods: {
		...mapActions([
			"getBonusCharge",
			"onBonusChargeFilter",
			"onBonusChargeEdit",
			"onExportLink",
			"onRemoveBonusCharge"
		]),
		async onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
				const { id } = line;
				this.itemId = id;
				this.isBonusChargeCreate = true;
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'bonus-charge' });
		},
		onClose() {
			this.isBonusChargeCreate = false;
		},
		onEvent({ flag }) {
			if (flag === "create") {
				this.itemId = null;
				this.isBonusChargeCreate = true;
			}
		},
		async onFilter({ filterModList }) {
			await this.onBonusChargeFilter(filterModList);
		},
		async onRemoveItem() {
			this.isPreloader = true;
			await this.onRemoveBonusCharge(this.removeId);
			this.isRemove = false;
			this.isPreloader = false;
		},
		onClickButton({ key, item }) {
			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}

			if (key === "edit") {
				if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
					this.itemId = item.id;
					this.isBonusChargeCreate = true;
				}
			}

			if (key === "view") {
				this.onPreview(item.file);
			}
		},
	},
	async created() {
		await this.getBonusCharge();
	},
};
</script>
